import React, { lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Loading from 'components/shared-components/Loading';

export const AuthViews = () => {
  return (
    <Suspense fallback={<Loading cover="page" fallback={true} />}>
      <Switch>
        <Route path={'/confirm'} component={lazy(() => import('./confirm'))} />
        <Route path={'/forgot'} component={lazy(() => import('./forgot'))} />
        <Route path={'/join'} component={lazy(() => import('./join'))} />
        <Route path={'/login'} component={lazy(() => import('./login'))} />
        <Route path={'/reset'} component={lazy(() => import('./reset'))} />
        <Route path={'/sign-up'} component={lazy(() => import('./sign-up'))} />
        <Redirect from={''} to={'/login'} />
      </Switch>
    </Suspense>
  )
}

export default AuthViews;

